/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicOrphanedJobRecovery extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicOrphanedJobRecovery");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicOrphanedJobRecovery.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicOrphanedJobRecovery>): BackgroundJobPayloadForPeriodicOrphanedJobRecovery {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicOrphanedJobRecovery(), model);
        BackgroundJobPayloadForPeriodicOrphanedJobRecovery.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicOrphanedJobRecovery>): BackgroundJobPayloadForPeriodicOrphanedJobRecovery {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicOrphanedJobRecovery.newInstance(<BackgroundJobPayloadForPeriodicOrphanedJobRecovery> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicOrphanedJobRecovery) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicOrphanedJobRecovery.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicOrphanedJobRecovery): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicOrphanedJobRecovery.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
